module.exports = __webpack_public_path__ + "static/img/8.e9d03ef1.png";